import axios from 'axios'
import { config } from './httpurl'
import qs from 'qs'

// 查询
export const SearchData = (params) => {
  return axios({
    url: config.rootUrl + 'dataCenter/getDataList', 
    method: 'POST',
    data:{...params}
  })
}
// 最新数据
export const NewestData = (params) => {
  return axios({
    url: config.rootUrl + 'dataCenter/getNewestList', 
    method: 'GET',
    params:params
  })
}
// 获取数据类型
export const GetAllModels = (params) => {
  return axios({
    url: config.rootUrl + 'dataCenter/getAllModels', 
    method: 'GET',
    params:params
  })
}
// 获取某条数据
export const GetOneData = (params) => {
  return axios({
    url: config.rootUrl + 'dataCenter/getOne', 
    method: 'GET',
    params:params
  })
}
// 获取省列表
export const GetAreaList = (parentId='000000') => {
  return axios({
    url: config.rootUrl + 'dataCenter/getAreaList', 
    method: 'GET',
    params:{parentId:parentId,modelId: 'ce0d06c3-aaa7-4749-89ac-252f134b8f6a'}
  })
}
// 获取分辨率
export const GetResolutionList = () => {
  return axios({
    url: config.rootUrl + 'satellite/getResolutionList', 
    method: 'GET',
  })
}
// 获取卫星
export const GetSatelliteList = (modelId) => {
  return axios({
    url: config.rootUrl + 'satellite/getSatelliteList', 
    method: 'GET',
    params:{modelId: modelId}
  })
}